module.exports = __webpack_public_path__ + "static/media/cuboid4NoCm.f3b61155.jpg";